import { render, staticRenderFns } from "./TableBasis.vue?vue&type=template&id=00825fbb&scoped=true&"
import script from "./TableBasis.vue?vue&type=script&lang=js&"
export * from "./TableBasis.vue?vue&type=script&lang=js&"
import style0 from "./TableBasis.vue?vue&type=style&index=0&id=00825fbb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00825fbb",
  null
  
)

export default component.exports